$(document).ready(function() {
  // When one of the checkboxes is changed, submit the filter form
  $('.checkbox-input').on('change', function() {
    $('#filter-form').submit();
  });

  // When a dropdown heading is clicked
  $('.dropdown-heading').on('click', function() {
    // Remove 'show' class from previously selected dropdown heading and hide its dropdown content
    $('.dropdown-heading').not(this).removeClass('show');
    $('.dropdown-content').not(this.nextElementSibling).slideUp('fast');

    // Toggle 'show' class on selected dropdown heading and show its dropdown content with a sliding animation
    $(this).toggleClass('show');
    $(this.nextElementSibling).slideToggle('fast');
    
    // Count the number of checked checkboxes and display the count within the title wrapper
    var dropdown = $(this).closest('.dropdown');
    var count = dropdown.find('.checkbox-input:checked').length;
    dropdown.find('.checkbox-count').text(count);
  });

  // Initial count of checked checkboxes within each dropdown
  $('.dropdown-content').each(function() {
    var dropdown = $(this).closest('.dropdown');
    var count = dropdown.find('.checkbox-input:checked').length;
    dropdown.find('.checkbox-count').text(count);
  });
});


$(document).ready(function() {
    $('.faq_toggle').click(function() {
      $(this).next('.faq_content').slideToggle('fast');
    });
  });


$(document).ready(function() {
  const transitionDuration = 300; // You can change the transition duration value here (in milliseconds)

  function setHeight(element, height) {
    element.animate({ height: height }, transitionDuration);
  }

  $('.product-header1_accordion').each(function() {
    const heading = $(this).find('.product-header1_heading');
    const details = $(this).find('.product-header1_details');
    const icon = $(this).find('.product-header1_accordion-icon');

    details.css('overflow', 'hidden');

    heading.on('click', function() {
      if (details.height() === 0) {
        setHeight(details, details[0].scrollHeight);
        icon.css({ 'transform': 'rotate(180deg)', 'transition': `transform ${transitionDuration}ms ease` });
      } else {
        setHeight(details, 0);
        icon.css({ 'transform': 'rotate(0deg)', 'transition': `transform ${transitionDuration}ms ease` });
      }
    });
  });
});

